export const pdfcss = (function () {
  let q = 1.35;

  return `
    @page {size: A4 landscape; margin: 0;}
    @media print{@page {size: A4 landscape; margin: 0;}}
    html, body.kt-subheader--transparent {font-size:16px !important;}
    .row {max-width:150% !important}
    .row:after {content:"";display:table;clear:both;}
    table {width:100%;border:0;border-collapse:collapse;text-align:left;}
    table td.grid {text-align:left;vertical-align:top;padding:0 8px 6px 0;}
    table td.grid:first-child {vertical-align:middle;padding-right:30px;width:${110 * q}px}
    table td.grid:last-child {padding:0 0 6px 0;}
    table td.grid table {width:auto}
    table td.grid table td {padding:6px 0 0 6px;vertical-align:top;}
    table td.grid table td:first-child {white-space:nowrap;}
    .kt-content {padding: 0 !important}
        
    #productApprovalCard-short {width: ${270 * q}mm !important;min-height: ${180 * q}mm !important;position:relative;}
    #productApprovalCard-short {font-size:1rem !important;page-break-after:always;font-weight:400 !important;border:0 !important;}
    #productApprovalCard-short .card-header {border:0 !important;}
    #productApprovalCard-short h5 {font-size:1.25rem !important;}
    
    .card-body {padding: 20px 0 0 !important}
    .card-body, .card-body-right-col, .card-body-left-col {position:relative}
    .footer-description {position:absolute;left:10px;right:10px;bottom:-${145 * q}px;height:${115 * q}px}
    
    .card-body-left-col .list-unstyled {min-height:${221.5 * q}px}
    .card-body-left-col .list-unstyled li {display:block;clear:both;}
    .card-body-left-col .badge-color-item {display:block;float:left;width:20px;height:20px;vertival-align:middle;border:1px #ebebeb solid;margin: 2px 5px 0 0}
        
    .img-artwork-main {height:${350 * q + 20}px}
    .img-artwork-main img {max-height:${350 * q}px;background: url(/media/bg/bg-chess-2.gif) !important;}
    .img-product-view {height:${200 * q + 20}px}
    .img-product-view img {max-height:${200 * q}px;}
  `;
})();
